import React from 'react';
import { NavBar, SideBar, Footer } from '../config/imports';

export default function ContainerBox({
  main,
  navbar = false,
  sidebar = false,
  footer = false,
  overlayMain = false,
  classMain = '',
}) {
  return (
    <div className='containerbox'>
      <>
        {navbar ? <NavBar /> : ''}
        <div className={classMain}>
          <main className={overlayMain ? ` bw-bg-overlay` : ''}>
            {sidebar ? <SideBar /> : ''}
            <div
              className={
                sidebar ? 'containerbox-main-right' : 'containerbox-main'
              }
            >
              {main}
            </div>
          </main>
        </div>
      </>
      {footer ? <Footer /> : null}
    </div>
  );
}
